<app-header></app-header>
<app-sidebar></app-sidebar>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-spin-fade" [fullScreen]="false">
  <p style="color: white"> กำลังโหลดข้อมูล... </p>
</ngx-spinner>

<div class="content-wrapper" style="min-height: 307px">
  <div class="card">
    <div class="card-header">
      <h1 class="headText2 text-primary">ค้นหาข้อมูลแปลงอ้อย </h1>
    </div>
    <div class="card-body no-print">
      <div class="row ">
        <div class="col-md-auto">
          <mat-form-field class="example-form-field" appearance="outline" style="width: 180px;">
            <mat-label>โควตา10หลัก</mat-label>
            <input matInput type="text" onkeypress='return event.charCode >= 48 && event.charCode <= 57' name="fmcode"
              [(ngModel)]="fmcode" maxlength="12">
            <button *ngIf="fmcode" matSuffix mat-icon-button aria-label="Clear" (click)="fmcode=''">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="col-md-auto text-center">
          <button mat-stroked-button color="primary" [disabled]="!fmcode" (click)="Load_data_cp();">ตกลง</button>
        </div>
        <div class="col-md-auto text-center">
          <div class="button-row">
            <button mat-raised-button color="primary" (click)="downloadExcel();" *ngIf="data_cpThis.length">
              <i class="far fa-file-excel"></i> Download </button>
            <button mat-raised-button color="accent" (click)="printPage();" *ngIf="data_cpThis.length">
              <mat-icon> print </mat-icon>
            </button>
          </div>
        </div>
        <div class="col-md-auto" *ngIf="lKeys.length> 0">
          <ul class="nav nav-tabs">
            <li class="nav-item" *ngFor="let i of lKeys">
              <a [ngClass]="{'nav-link btn btn-outline-success':true,'active': showacti == i}"
                (click)="check(i,lData[i])"><i class='fas fa-book'></i> ปี {{i}}
                <span class="badge bg-warning">{{ lData[i].length }}</span>
              </a>
            </li>
            <!--<li class="nav-item">
                <a (click)="check(0)" [ngClass]="{'nav-link':true,'active': showacti == 0}">
                  <i class='fas fa-book'></i> ทุกปี <span class="badge bg-warning">{{ data_Allcp.length }}</span>
                </a>
              </li>-->
          </ul>
        </div>
      </div>
    </div>

    <div class="card-body table-responsive p-2" style="max-height: 650px">
      <table #tb_landno class="table table-hover table-head-fixed table-bordered">
        <thead>
          <tr class="headText text-primary" style="text-align:center;">
            <th scope="col">#</th>
            <th scope="col">ปี</th>
            <th scope="col">หมายเลขแปลง</th>
            <th scope="col">ชื่อ - สกุล</th>
            <th scope="col">ประเภทอ้อย</th>
            <th scope="col">พื้นที่</th>
            <th scope="col">พันธุ์อ้อย</th>
            <th scope="col">กรรมสิทธิ์</th>
            <th scope="col">ปลูกเสร็จ</th>
            <th scope="col">วันปลูก</th>
            <th scope="col">รูท</th>
            <th scope="col">โซน</th>
            <th scope="col">กลุ่มตัด</th>
            <th scope="col">ตัน/ไร่</th>
            <th scope="col">ประเมินตัน</th>
            <th scope="col">เข้าหีบ</th>
            <th scope="col">CCSเฉลี่ย</th>
            <th scope="col">ตัดพันธุ์</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of data_cpThis; index as i" style="text-align:center;">
            <th scope="row">{{i+1}}</th>
            <td>{{item.year_th}}</td>
            <td>{{item.intlandno}}</td>
            <td>{{item.fmname}}</td>
            <td>{{item.CaneTypeName}}</td>
            <td>{{item.landvalue | number:'1.2-2'}}</td>
            <td>{{item.seedname}}</td>
            <td>{{item.plotdesc}}</td>
            <td>{{item.growed1}}</td>
            <td>{{item.PlantDate|date}}</td>
            <td>{{item.route}}</td>
            <td>{{item.supzone}}</td>
            <td>{{item.groupCode}}</td>
            <td>{{item.Ton | number:'1.1-2'}}</td>
            <td>{{item.Assess | number:'1.2-2'}}</td>
            <td>{{item.canein | number:'1.2-2'}}</td>
            <td>{{item.ccs | number:'1.2-2'}}</td>
            <td>{{item.Cutseed | number:'1.1-2'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-footer></app-footer>